<template>
  <div class="content">
    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Enviar notificações"
          buttonText="Nova notificação"
          :buttonFunction="modalNovaNotificacao"
        />
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-select
                  v-model="selectedClients"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  label="Clientes"
                  multiple
                  prepend-icon="mdi-office-building"
                >
                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @mousedown.prevent
                      @click="filterByClients"
                    >
                      <v-list-item-action>
                        <v-icon
                          :color="
                            selectedClients.length > 0 ? 'indigo darken-4' : ''
                          "
                        >
                          {{ icon }}
                        </v-icon>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>
                          Selecionar todos
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="allNotifications"
          class="elevation-1"
          no-data-text="Nenhuma notificação cadastrada"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class>{{ item.title }}</td>
              <td class>{{ item.subtitle }}</td>
              <td class>{{ item.created_at | formatDate }}</td>
              <td class>
                {{
                  item.notification_client
                    | formatClientArray(clients)
                    | formatClientName
                }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- MODAL NEW NOTIFICATION-->
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="register_notification" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Nova Notificação</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-layout align-baseline>
                    <v-autocomplete
                      multiple
                      persistent-hint
                      class="input mr-5"
                      :menu-props="{ maxHeight: '400' }"
                      :items="clients"
                      item-text="name"
                      item-value="id"
                      label="Clientes"
                      v-model="notification.clients"
                    ></v-autocomplete>
                    <div class="buttons">
                      <v-btn
                        small
                        class="mb-2"
                        color="primary"
                        @click="selectAllClients()"
                        >Selecionar todos</v-btn
                      >
                      <v-btn
                        v-if="notification.clients.length > 0"
                        x-small
                        color="error"
                        @click="removeAllClients()"
                        >Remover todos</v-btn
                      >
                    </div>
                  </v-layout>
                  <v-layout align-baseline v-if="this.users.length > 0">
                    <v-autocomplete
                      multiple
                      persistent-hint
                      class="input mr-5"
                      :menu-props="{ maxHeight: '400' }"
                      :items="users"
                      item-text="name"
                      item-value="id"
                      label="Usuários:"
                      v-model="notification.users"
                    ></v-autocomplete>
                    <div class="buttons">
                      <v-btn
                        small
                        class="mb-2"
                        color="primary"
                        @click="selectAllUsers()"
                        >Selecionar todos</v-btn
                      >
                      <v-btn
                        v-if="notification.users.length > 0"
                        x-small
                        color="error"
                        @click="removeAllUsers()"
                        >Remover todos</v-btn
                      >
                    </div>
                  </v-layout>
                  <v-text-field
                    label="Título"
                    class="input"
                    v-model="notification.title"
                  ></v-text-field>
                  <v-text-field
                    label="Mensagem"
                    class="input"
                    v-model="notification.subtitle"
                  ></v-text-field>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="
                  clearForm();
                  register_notification = false;
                "
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" @click="send()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <div justify-center></div>
  </div>
</template>

<script>
import ClientController from '../../controllers/ClientController';
import NotificationController from '../../controllers/NotificationController';
import UserController from '../../controllers/UserController';
import moment from 'moment';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';

export default {
  components: {
    TitleWithButton,
  },

  mounted() {
    this.getClients();
    this.getNotifications();
  },

  data() {
    return {
      notificationController: new NotificationController(this.$resource),
      clientController: new ClientController(this.$resource),
      userController: new UserController(this.$resource),
      clients: [],
      users: [],
      register_notification: false,
      notifications: [],
      notification: {
        clients: [],
        users: [],
        title: '',
        subtitle: '',
      },
      headers: [
        { text: 'Título', value: 'title' },
        { text: 'Subtítulo', value: 'subtitle' },
        { text: 'Criado em', value: 'created_at' },
        { text: 'Cliente', value: 'notification_client' },
      ],

      selectedClients: [],
    };
  },

  computed: {
    filterAllClients() {
      return this.selectedClients.length === this.clients.length;
    },

    filterSomeClients() {
      return this.selectedClients.length > 0 && !this.filterAllClients;
    },

    allNotifications() {
      if (this.filterSomeClients) {
        return this.notifications.filter(notificationObject => {
          return notificationObject.notification_client.some(item => {
            return this.selectedClients.includes(item.client_id);
          });
        });
      }
      return this.notifications;
    },

    icon() {
      if (this.filterAllClients) return 'mdi-close-box';
      if (this.filterSomeClients) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },

  methods: {
    filterByClients() {
      this.$nextTick(() => {
        if (this.filterAllClients) {
          this.selectedClients = [];
        } else {
          this.selectedClients = this.clients.slice();
        }
      });
    },

    async getNotifications() {
      try {
        const res = await this.notificationController.get();
        this.notifications = res.data;
      } catch (e) {
        console.error(e);
      }
    },

    getClients() {
      this.clientController
        .getAllClients()
        .then(clients => (this.clients = clients));
    },

    async getClientUsers(clientId) {
      this.users = await this.userController.getUsersActiveByClientId(clientId);
    },

    async send() {
      try {
        if (
          Boolean(this.notification.clients) &&
          Boolean(this.notification.subtitle) &&
          Boolean(this.notification.title) &&
          Boolean(this.notification.users)
        ) {
          await this.notificationController.sendNotification(this.notification);
          this.$awn.success('Notificação enviada.');
          this.register_notification = false;
          this.getNotifications();
          this.clearForm();
          return;
        }

        this.$awn.alert('Preencha todos os campos corretamente');
      } catch (error) {
        this.$awn.alert(error);
      }
    },

    modalNovaNotificacao() {
      this.register_notification = true;
    },

    selectAllClients() {
      this.notification.clients = this.clients.map(client => client.id);
    },

    removeAllClients() {
      this.notification.clients = [];
    },

    selectAllUsers() {
      this.notification.users = this.users.map(user => user.id);
    },

    removeAllUsers() {
      this.notification.users = [];
    },

    clearForm() {
      this.notification = {
        clients: [],
        users: [],
        title: '',
        subtitle: '',
      };
    },
  },

  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY HH:mm');
      }
    },

    formatClientArray(clientsNotificationArray, clients) {
      if (Boolean(clientsNotificationArray) && Boolean(clients)) {
        return clientsNotificationArray.map(client => {
          let clientId = client.client_id;
          let clientObject = clients.find(c => c.id === clientId);
          return clientObject ? clientObject.name : clientId;
        });
      }
    },

    formatClientName(clientsArray) {
      return clientsArray.join(', ');
    },
  },

  watch: {
    'notification.clients': function(newValue) {
      for (let client of newValue) {
        this.getClientUsers(client);
      }
    },
  },
};
</script>

<style>
.container {
  max-width: 100%;
}
.input {
  width: 600px;
}
.buttons {
  display: flex;
  flex-direction: column;
}
</style>
